module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("My profound gratitude goes to my friends, Mr Joshua Ariyo and Kelvin Nwaigwe. Your support and encouragement have been immensely empowering.")]), _vm._v(" "), _c('p', [_vm._v("Words fail me to adequately express my appreciation to those who have shared their stories and experiences with me. Thank you for trusting me with your truth, and for inspiring me to write this book.")]), _vm._v(" "), _c('p', [_vm._v("To the readers, your honest feedback has continuously motivated me to record my experiences and thoughts. Thank you for being the reason I write.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0